import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { SupportUsersViewModalComponent } from './support-users-view-modal/support-users-view-modal.component';
import { UmSummaryService, UserInfo } from 'src/app/services/um/um-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-users-modal',
  templateUrl: './support-users-modal.component.html',
  styleUrls: ['./support-users-modal.component.scss']
})
export class SupportUsersModalComponent implements OnInit {
  @Input() public Content: any;

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  content: any
  heading: any

  advanceSearch;
  collapesedOrNot: Boolean = false;
  userForm: UntypedFormGroup;
  Tempoperations: { name: string; id: string; }[];
  DepartmentList: any[] = [];
  RolesList: any[] = [];
  StatusList: any[] = [];
  IsResendRequired: boolean = false;
  UserName: string;
  ISANALYTICSCONFIGURED: boolean;
  ISORGACCOUNTINLOGI: boolean;
  constructor(
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private modalRef: NgbActiveModal
  ) {

  }

  ngOnInit() {
    this.StatusList.push({ label: "All", value: 101, checked: true });
    this.StatusList.push({ label: "Active", value: 1 });
    this.StatusList.push({ label: "Inactive", value: 0 });

    this.userForm = new UntypedFormGroup({
      TITLE: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl(""),
      DEPARTMENT_ID: new UntypedFormControl(""),
      ROLEID: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl(101),
      ORGANIZATION_ID: new UntypedFormControl("")
    });
    this.columnDefs = [
      {
        "headerName": "Username",
        "field": "TITLE",
      },
      {
        "headerName": "Email ID",
        "field": "EMAIL"
      },
      {
        "headerName": "Status",
        "field": "StatusExt"
      }
    ];

    this.ISANALYTICSCONFIGURED = this.Content.content.OrgData.IS_ANALYTICS_CONFIGURED;
    this.ISORGACCOUNTINLOGI = this.Content.content.OrgData.IS_ORG_ACCOUNT_IN_LOGI;
    this.getMasterData();
  }



  getMasterData() {
    this.summaryService.getUserSearchMaster().subscribe(summary => {
      this.DepartmentList = summary["MasterData1"];
      this.DepartmentList = [{ label: "All", value: "", checked: true }].concat(this.DepartmentList);
      this.RolesList = summary["MasterData2"];
      this.RolesList = [{ label: "All", value: "", checked: true }].concat(this.RolesList);

      var MailData = summary["MasterData3"][0];
      if (MailData != null) {
        this.IsResendRequired = MailData.value == "yes" ? true : false;
      }
      this.setSummary();
    });
  }
  setRowOperations(rowData: any[]): any {
    this.Tempoperations = [];
    rowData.forEach(element => {
      this.Tempoperations = [];

      this.Tempoperations.push({
        "name": "Edit",
        "id": "edit"
      }, {
        "name": "Add User",
        "id": "add"
      });
      let Tempoperations1 = [];
      Tempoperations1.push({
        "name": "Edit",
        "id": "edit"
      }, {
        "name": "Add User",
        "id": "add"
      });
      if (this.IsResendRequired && element.IsTempPwd == "Yes" && element.StatusExt == "Active") {
        Tempoperations1.push({
          "name": "Resend Email",
          "id": "Resend"
        });
      }

      if (element.IsTempPwd == "Yes") {
        if (this.Content.content.OrgData.IS_ANALYTICS_CONFIGURED == true && this.Content.content.OrgData.IS_ORG_ACCOUNT_IN_LOGI == true && element.IS_USER_LINKED_WITH_LOGI == false) {
          Tempoperations1.push({
            "name": "Refresh",
            "id": "Refresh"
          });

        }
        element["Operations"] = Tempoperations1.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
      else {
        if (this.Content.content.OrgData.IS_ANALYTICS_CONFIGURED == true && this.Content.content.OrgData.IS_ORG_ACCOUNT_IN_LOGI == true && element.IS_USER_LINKED_WITH_LOGI == false) {
          this.Tempoperations.push({
            "name": "Refresh",
            "id": "Refresh"
          });

        }
        element["Operations"] = this.Tempoperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
    });
    this.operations = this.Tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    return rowData;
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const Modalref = this.modalService.open(SupportUsersViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    Modalref.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this.selectedRow['ID'], OrgId: this.Content.content.id }
    }
  }

  add() {
    if (this.IsResendRequired) {
      this.summaryService.checkInternalUser(this.Content.content.id).subscribe(result => {
        if (result) {
          let modalRef = this.modalService.open(SupportUsersViewModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true
          });
          modalRef.componentInstance.Content = {
            heading: 'Add',
            content: { id: "", OrgId: this.Content.content.id }
          }
          modalRef.result.then((result) => {
            this.setSummary();
          });

        }
        else {
          this.commonservice.ValidationBanner("The User count has reached the limit set for organization. Kindly update the limit to save the user details");
        }
      });
    }
    else {
      this.commonservice.ValidationBanner("Please configure outgoing email to save the user details");
    }

  }

  edit(RecordData: any) {

    let modalRef = this['self'].modalService.open(SupportUsersViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'], OrgId: this['self'].Content.content.id, IsAnalyticsConfig: this['self'].ISANALYTICSCONFIGURED, IsOrgaccinLogi: this['self'].ISORGACCOUNTINLOGI }
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }
  view(RecordData: any) {
    let modalRef = this['self'].modalService.open(SupportUsersViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: RecordData['ID'], OrgId: this['self'].Content.content.id, IsAnalyticsConfig: this['self'].ISANALYTICSCONFIGURED, IsOrgaccinLogi: this['self'].ISORGACCOUNTINLOGI }
    }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  setSummary() {
    let orgId = this.Content.content.id;
    this.SearchClear();
    this.summaryService.getUserSummary(orgId).subscribe(summary => {
      this.rowData = this.setRowOperations(summary);
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.userForm = new UntypedFormGroup({
      TITLE: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl(""),
      DEPARTMENT_ID: new UntypedFormControl(""),
      ROLEID: new UntypedFormControl(""),
      RECORD_STATE: new UntypedFormControl(101),
      ORGANIZATION_ID: new UntypedFormControl("")
    });
  }

  AdvanceSearch() {
    let FormData = this.userForm.getRawValue();
    FormData["ORGANIZATION_ID"] = this.Content.content.id;
    if (FormData["RECORD_STATE"] == null || FormData["RECORD_STATE"] == undefined) {
      FormData["RECORD_STATE"] = 101;
    }
    this.summaryService.getUserSearchSummary(FormData).subscribe(summary => {
      this.rowData = this.setRowOperations(summary);
    });
  }

  ClosePopup() {
    this.modalRef.dismiss();
  }

  Resend(RecordData: any) {
    let id = RecordData["ID"];
    this['self'].summaryService.resendUserEmail(id, this['self'].Content.content.id).subscribe(summary => {
      if (summary != null && summary.Status == 0) {
        this['self'].commonservice.SuccessBanner(summary.Message);
      } else if (summary.ErrorCode == "MAILEXCEPTION") {
        this['self'].commonservice.ValidationBanner("Unable to send email to users. Please try again");
      }
    });
  }

  Refresh(RecordData: any) {
    let row = RecordData;
    this.UserName = row.TITLE;
    var user = new UserInfo;
    user["ID"] = row.ID;
    user["Username"] = row.EMAIL;
    user["Email"] = row.EMAIL;
    user["OrgId"] = row.ORGANIZATION_ID;
    this['self'].summaryService.refreshUser(user).subscribe(response => {
      if (response.Status == 0) {
        this['self'].commonservice.SuccessBanner("Analytics account created successfully for the user '" + this.UserName + "'");
        this['self'].setSummary();
      } else {
        this['self'].commonservice.ValidationBanner("The analytics account is not created for the user '" + this.UserName + "'. Please refresh the details to create an account. ");
      }
    })
  }
}
